class CategoriaAto {
    constructor(
        {
            id = null, 
            nome_categoria  = null, 
            ind_ativo  = null, 
            dt_criacao  = null, 
            dt_atualizacao  = null, 
        } = {}
    ) {
        this.id = id; 
        this.nome_categoria  = nome_categoria;
        this.ind_ativo = ind_ativo; 
        this.dt_criacao = dt_criacao; 
        this.dt_atualizacao = dt_atualizacao;             
    }
}

export default CategoriaAto;